module.exports = __webpack_public_path__ + "static/media/loading-gray.a6134d59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/loading-gray.svg
// module id = 422
// module chunks = 0